  import React from "react";
  import { Routes, Route } from "react-router-dom";

  // Негізгі компоненттер
  import PersistLogin from "./components/auth/PersistLogin";
  import DashboardLayout from "./components/layouts/DashboardLayout";
  import ProtectedRoute from "./components/common/ProtectedRoute";

  // Жалпы беттер
  import HiPage from "./pages/HiPage";
  import AuthPage from "./pages/AuthPage";
  import LandingPage from "./pages/LandingPage";
  import ForgotPassword from "./pages/ForgotPassword";
  import ResetPassword from "./pages/ResetPassword";
  import GoogleAuthCallback from "./pages/GoogleAuthCallback";
  import ForbiddenPage from "./pages/ForbiddenPage";
  import ProfilePage from "./pages/common/ProfilePage";
  import PaymentSuccessPage from "./pages/common/PaymentSuccessPage";
  import FormattingHelpPage from "./pages/common/FormattingHelpPage";
  import SettingsPage from "./pages/common/SettingsPage";
  import LegalPage from "./pages/common/LegalPage";

  // Рөлдерге арналған беттер
  import StudentDashboard from "./pages/student/StudentDashboard";
  import MyCourses from "./pages/student/MyCourses";
  import CourseViewer from "./pages/student/CourseViewer";
  import InstructorDashboard from "./pages/instructor/InstructorDashboard";
  import InstructorAnalyticsPage from "./pages/instructor/InstructorAnalyticsPage";
  import InstructorFinancePage from "./pages/instructor/InstructorFinancePage";
  import AdminDashboard from "./pages/admin/AdminDashboard";
  import CategoriesPage from "./pages/admin/CategoriesPage";
  import MyCourssesPage from "./pages/instructor/MyCourssesPage"
  import AdminCourseManagement from "./pages/admin/AdminCourseManagement";
  import AdminCoursePreview from "./pages/admin/AdminCoursePreview";
  import AdminUsersPage from "./pages/admin/AdminUsersPage";
  import AdminReviewsPage from "./pages/admin/AdminReviewsPage";
  import AdminOrdersPage from "./pages/admin/AdminOrdersPage";
  import AdminP2pPage from "./pages/admin/AdminP2pPage";
  import AdminStudentLookup from "./pages/admin/AdminStudentLookup";
  import AdminAuditLogPage from "./pages/admin/AdminAuditLogPage";
  // --- ЖАҢА ИМПОРТТАР ---
  import CreateCoursePage from "./pages/instructor/CreateCoursePage";
  import CourseEditorPage from "./pages/instructor/CourseEditorPage";
  import CourseList from "./pages/customer/CourseList";
  import CourseDetail from "./pages/customer/CourseDetailPage";
  import InstructorProfileView from "./pages/instructor/InstructorProfileViewPage";

  // Quizzes
  import MyQuizzesPage from "./pages/student/MyQuizzesPage";
  import QuizCreatePage from "./pages/student/QuizCreatePage";
  import QuizEditPage from "./pages/student/QuizEditPage";
  import QuizStatsPage from "./pages/student/QuizStatsPage";
  import PublicQuizPage from "./pages/public/PublicQuizPage";
  import CertificateVerifyPage from "./pages/public/CertificateVerifyPage";
  import MyCertificatesPage from "./pages/student/MyCertificatesPage";
  
  function App() {
    return (
      <Routes>
        <Route element={<PersistLogin />}>
          {/* Жалпы беттер.
              «/» — публичный лендинг (single-page с anchor-секциями).
              «/auth» — форма логина/регистрации.
              «/welcome» — старая HiPage оставлена на случай если где-то
              ещё ссылаются (без вреда). */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/welcome" element={<HiPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/google-callback" element={<GoogleAuthCallback />} />
          <Route path="/forbidden" element={<ForbiddenPage />} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />

          {/* Public quiz — без DashboardLayout, со своим header'ом + Login/Register CTA */}
          <Route path="/q/:slug" element={<PublicQuizPage />} />

          {/* Публичная верификация сертификата — открывается при сканировании
              QR на PDF. Без DashboardLayout — отдельный standalone landing
              для работодателей/третьих лиц. */}
          <Route path="/verify/:token" element={<CertificateVerifyPage />} />

          <Route element={<DashboardLayout />}>
              {/* Public + auth: каталог и детали курса теперь в стеке dashboard layout */}
              <Route path="/courses" element={<CourseList />} />
              <Route path="/course/:courseId" element={<CourseDetail />} />

              <Route path="/instructor/:instructorId" element={<InstructorProfileView />} />
            <Route element={<ProtectedRoute allowedRoles={['student', 'instructor', 'admin']} />}>
              <Route path="/profile" element={<ProfilePage />} />
              {/* Справка по форматированию — доступна всем авторизованным.
                  Markdown + KaTeX используется в редакторе теории, квизов
                  и описаний — единая справка покрывает все случаи. */}
              <Route path="/help/formatting" element={<FormattingHelpPage />} />
              {/* Настройки аккаунта — общая страница для всех ролей.
                  Смена пароля, язык, тема + ссылки на правовые документы. */}
              <Route path="/settings" element={<SettingsPage />} />
              {/* Правовые документы — один компонент, slug определяет
                  какой документ показать. Контент в i18n RU+KK. */}
              <Route path="/legal/:slug" element={<LegalPage />} />
              {/* Мои сертификаты — доступны всем ролям, у инструктора/админа
                  тоже могут быть пройденные курсы. */}
              <Route path="/my-certificates" element={<MyCertificatesPage />} />
            </Route>

            {/* === СТУДЕНТ ЖОЛДАРЫ === */}
            <Route element={<ProtectedRoute allowedRoles={['student']} />}>
              <Route path="/dashboard/student" element={<StudentDashboard />} />
              <Route path="/my-courses" element={<MyCourses />} />
              <Route path="/my-certificates" element={<MyCertificatesPage />} />

              {/* Quizzes (owner side) */}
              <Route path="/dashboard/student/quizzes" element={<MyQuizzesPage />} />
              <Route path="/dashboard/student/quizzes/create" element={<QuizCreatePage />} />
              <Route path="/dashboard/student/quizzes/:id/edit" element={<QuizEditPage />} />
              <Route path="/dashboard/student/quizzes/:id/stats" element={<QuizStatsPage />} />
            </Route>

            {/* /learn/:courseId — доступен студенту (для купленных курсов)
                И инструктору (для preview своего курса). Бэкенд сам проверяет:
                либо есть enrollment, либо юзер = автор курса. */}
            <Route element={<ProtectedRoute allowedRoles={['student', 'instructor']} />}>
              <Route path="/learn/:courseId" element={<CourseViewer />} />
            </Route>

            {/* === ИНСТРУКТОР ЖОЛДАРЫ === */}
            <Route element={<ProtectedRoute allowedRoles={['instructor']} />}>
              <Route path="/dashboard/instructor" element={<InstructorDashboard />} />
              <Route path="/dashboard/instructor/courses" element={<InstructorDashboard />} />
              <Route path="/dashboard/instructor/analytics" element={<InstructorAnalyticsPage />} />
              <Route path="/dashboard/instructor/finance" element={<InstructorFinancePage />} />
              <Route path="/dashboard/instructor/my-courses" element={<MyCourssesPage />} />
              <Route path="/dashboard/instructor/create-course" element={<CreateCoursePage />} /> 
              <Route path="/dashboard/instructor/create-course/:courseId/edit" element={<CourseEditorPage />} />
            </Route>

            {/* === АДМИН ЖОЛДАРЫ === */}
            <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
              <Route path="/dashboard/admin" element={<AdminDashboard />} />
              <Route path="/dashboard/admin/categories" element={<CategoriesPage />} />
              <Route path="/dashboard/admin/course-management" element={<AdminCourseManagement />} />
              <Route path="/dashboard/admin/course-management/:courseId" element={<AdminCoursePreview />} />
              <Route path="/dashboard/admin/users" element={<AdminUsersPage />} />
              <Route path="/dashboard/admin/reviews" element={<AdminReviewsPage />} />
              <Route path="/dashboard/admin/orders" element={<AdminOrdersPage />} />
              <Route path="/dashboard/admin/payments" element={<AdminP2pPage />} />
              <Route path="/dashboard/admin/student-lookup" element={<AdminStudentLookup />} />
              <Route path="/dashboard/admin/audit-log" element={<AdminAuditLogPage />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    );
  }

  export default App;

